// 工作交接模块路由配置
export const workHandoverMain = [
  {
    name: 'work_handover',
    path: '/work_handover',
    meta: {
      title: '工作交接',
      icon: 'handover'
    }
  },
  {
    name: 'work_handover_handover',
    path: '/work_handover/handover',
    component: () => import('/@/views/plugins/work_handover/handover.vue'),
    meta: {
      title: '每日工作',
      icon: 'daily',
      plugin: 'work_handover',
      keepAlive: true
    }
  },
  {
    name: 'work_handover_records',
    path: '/work_handover/records',
    component: () => import('/@/views/plugins/work_handover/records.vue'),
    meta: {
      title: '工作记录',
      icon: 'records',
      plugin: 'work_handover'
    }
  },
  {
    name: 'work_handover_notifiers',
    path: '/work_handover/notifiers',
    component: () => import('/@/views/plugins/work_handover/notifiers.vue'),
    meta: {
      title: '通知人员',
      icon: 'user',
      plugin: 'work_handover'
    }
  },
  {
    name: 'work_handover_notebook',
    path: '/work_handover/notebook',
    component: () => import('/@/views/plugins/work_handover/notebook.vue'),
    meta: {
      title: '记事本'
    }
  }
]

export default workHandoverMain
